import { JsonSectionsRepository } from "../../repositories/implementations/JsonSectionsRepository";
import { GetPrologueUseCase } from "./GetPrologueUseCase";

export const getPrologueUseCase = new GetPrologueUseCase(
    new JsonSectionsRepository()
);